import { FloatingTextinput } from '@/ui/floating-textinput/floating-textinput';
import { AddressWrapper } from '@/components/Address-Wrapper';

export const SimpleOrderFields = ({
	user,
	asSimpleOrder,
	requiredOrderFields,
	clientName,
	setClientName,
	validateName,
	errorName,
	onFocusShop,
	clientPhone,
	setClientPhone,
	validatePhone,
	errorPhone,
	clientAddress,
	setClientAddress,
	validateAddress,
	errorAddress,
	clientLocation,
	setClientLocation,
	setErrorLocation,
	errorLocation,
}) => {
	if (!asSimpleOrder) return null;

	return (
		<>
			{requiredOrderFields?.freeClient?.children?.name?.mode && (
				<FloatingTextinput
					value={clientName}
					label='Όνομα'
					onChange={e => setClientName(e)}
					onBlur={validateName}
					error={errorName}
					errorText='Το όνομα δεν είναι έγκυρο'
					onFocus={onFocusShop}
					size='lg'
				/>
			)}
			{requiredOrderFields?.freeClient?.children?.phone?.mode && (
				<FloatingTextinput
					value={clientPhone}
					label='Τηλέφωνο πελάτη'
					inputMode='tel'
					onChange={e => setClientPhone(e)}
					onBlur={validatePhone}
					error={errorPhone}
					errorText='Το τηλέφωνο δεν είναι έγκυρο'
					onFocus={onFocusShop}
					size='lg'
				/>
			)}
			{requiredOrderFields?.freeClient?.children?.address?.mode && (
				<FloatingTextinput
					value={clientAddress}
					label='Διεύθυνση πελάτη'
					onChange={e => setClientAddress(e)}
					onBlur={validateAddress}
					error={errorAddress}
					errorText='Η διεύθυνση δεν είναι έγκυρη'
					onFocus={onFocusShop}
					size='lg'
				/>
			)}
			{requiredOrderFields?.freeClient?.children?.location?.mode && (
				// The geocoded counterpart of the free-text field above, and a
				// separate question: this is the one that carries coordinates, so
				// it is what puts the order on the live map and lets it be priced
				// by distance.
				<div className='w-[252px] max-w-full'>
					<AddressWrapper
						user={user}
						label='Τοποθεσία πελάτη'
						withinServiceArea
						address={clientLocation}
						setAddress={setClientLocation}
						errorAddress={errorLocation}
						setErrorAddress={setErrorLocation}
						optional={requiredOrderFields.freeClient.children.location.mode !== 'required'}
						onFocus={onFocusShop}
					/>
				</div>
			)}
		</>
	);
};
